import React from 'react';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components/macro';
import { JoinButton } from '../../buttons/JoinButton';
import { LAST_CHANCE_SECTION } from 'src/client/constants/joinCampaigns';

type Props = {
  className?: string;
  show?: boolean;
  site: { name: string };
  discoverMoreLink: string;
};

export const LastChanceSection = (props: Props) => {
  const { className = '', show = true, site, discoverMoreLink } = props;

  if (!show) return null;

  return (
    <StyledLastChanceSection className={`${className} last-chance-wrapper`}>
      <ButtonsContainer>
        <JoinAction campaign={LAST_CHANCE_SECTION} className="btn btn-primary">
          Sign Up Today
        </JoinAction>
        <DiscoverMoreLink to={discoverMoreLink} className="btn btn-secondary">
          Discover More {site.name}
        </DiscoverMoreLink>
      </ButtonsContainer>
    </StyledLastChanceSection>
  );
};

const buttonStyles = css`
  min-width: 270px;
  box-sizing: border-box;
  padding: 15px;
  border-radius: 3px;
  font-size: 1.15rem;
  margin: 30px 20px;
  transition: 0.3s color;
  display: inline-block;
`;

const StyledLastChanceSection = styled.section`
  padding: 45px 0;

  @media (max-width: 767px) {
    padding: 0;
  }
`;

const ButtonsContainer = styled.div`
  text-align: center;
`;

const JoinAction = styled(JoinButton)`
  ${buttonStyles}
  color: ${(props) => props.theme.primaryBtn1Text};

  @media (max-width: 767px) {
    margin: 13px auto;
  }
`;

const DiscoverMoreLink = styled(NavLink)`
  ${buttonStyles}
  color: ${(props) => props.theme.secondaryBtn1Text};
  margin-left: auto;
  margin-right: auto;
  text-decoration: none;

  :hover,
  :focus,
  :visited {
    text-decoration: none;
  }
`;
